import { PlatformSlug } from 'constants/consts'
import { getFeatureConfig } from 'platformConfig'

export type NoteEnvironmentConfig = {
  hasGoogleDrive: boolean
  hasBoosterEnv: boolean
}

export const DEFAULT_NOTE_ENVIRONMENT_CONFIG: NoteEnvironmentConfig = {
  hasGoogleDrive: true,
  hasBoosterEnv: false,
}

export const NOTE_ENVIRONMENT_CONFIG: Partial<Record<PlatformSlug, NoteEnvironmentConfig>> = {
  [PlatformSlug.DATBooster]: { hasGoogleDrive: true, hasBoosterEnv: true },
  [PlatformSlug.OATBooster]: { hasGoogleDrive: true, hasBoosterEnv: true },
  [PlatformSlug.DATCrusher]: { hasGoogleDrive: true, hasBoosterEnv: true },
  [PlatformSlug.INBDEBooster]: { hasGoogleDrive: true, hasBoosterEnv: true },
  [PlatformSlug.NBDHEBooster]: { hasGoogleDrive: true, hasBoosterEnv: true },
  [PlatformSlug.NDEBCrusher]: { hasGoogleDrive: true, hasBoosterEnv: true },
  [PlatformSlug.GREBooster]: { hasGoogleDrive: true, hasBoosterEnv: true },
  [PlatformSlug.NBEOPartOne]: { hasGoogleDrive: false, hasBoosterEnv: true },
  [PlatformSlug.DLOSCE]: { hasGoogleDrive: true, hasBoosterEnv: true },
}

export const getNoteEnvironmentConfig = (slug?: PlatformSlug) =>
  getFeatureConfig(NOTE_ENVIRONMENT_CONFIG, slug) ?? DEFAULT_NOTE_ENVIRONMENT_CONFIG
